<template lang="pug">
.vacancy-respond
  h3 Reageer op deze vacature
  .form
    .form-element
      RomatchInput(label="Naam *" v-model="reaction.name" @blur="$v.reaction.name.$touch()" :disabled="sending")
      .validation-error(v-show="$v.reaction.name.$error") Dit veld is vereist
    .form-element
      RomatchInput(label="E-mailadres *" v-model="reaction.email" @blur="$v.reaction.email.$touch()" :disabled="sending")
      .validation-error(v-show="$v.reaction.email.$error") Dit veld is vereist
    .form-element
      RomatchInput(label="Telefoonnummer" v-model="reaction.phoneNumber" :disabled="sending")
    .form-element
      RomatchTextarea(label="motivatie" v-model="reaction.message" :disabled="sending")
    .form-element
      RomatchFilePicker(label="C.V. (max 2MB)" @change="fileChange" :disabled="sending")
    .form-buttons
      RomatchButton(@click="goBack" :disabled="sending") Terug
      RomatchButton(@click="submit" :disabled="$v.$invalid || sending") Verstuur
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import ContactService from '@/services/ContactService.js'
import { Storage } from 'aws-amplify'

export default {
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reaction: {
        id: null,
        name: null,
        email: null,
        phoneNumber: null,
        message: null,
        vacancyID: this.vacancy.id,
        cvFileKey: null,
      },
      sending: false,
      file: null,
    }
  },
  validations: {
    reaction: {
      name: { required },
      email: { required, email },
    },
  },
  methods: {
    tryit: async f => {
      try {
        return await f()
      } catch (e) {
        console.error(e)
      }
    },

    async submit() {
      this.sending = true
      try {
        const storageResponse = await this.storeCV()
        this.reaction.cvFileKey = storageResponse ? storageResponse.key : null
        await this.storeReaction()
        await this.sendEmail()
        this.$alert(
          'Bedankt voor je reactie. We sturen je een bevestiging per email en zullen daarna spoedig contact opnemen.'
        )
      } catch (e) {
        console.error(e)
        this.$alert(
          'Er ging iets mis. Probeer later opnieuw of stuur een email naar: info@rondagroep.nl'
        )
      }
      this.sending = false
    },

    async storeCV() {
      const file = this.file
      if (!file) return null
      return await this.tryit(async () => {
        const storageFileName = this.createStoregeFileName(file.name)
        const storageResult = await Storage.put(storageFileName, file)
        return storageResult
      })
    },

    createStoregeFileName(fileName) {
      let date = new Date()
      let timestamp = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

      const randomPrefix = Math.random()
        .toString()
        .slice(2)
      return `${timestamp}_${randomPrefix}_${fileName}`
    },

    async storeReaction() {
      return await this.tryit(async () => {
        return await ContactService.storeVacancyReaction(this.reaction)
      })
    },

    async sendEmail() {
      return await this.tryit(async () => {
        return await ContactService.sendReaction({
          ...this.reaction,
          vacancyTitle: this.vacancy.title,
        })
      })
    },

    goBack() {
      this.$router.push({ name: 'vacancies' })
    },

    fileChange(e) {
      this.file = null
      const files = e.currentTarget.files
      if (files.length > 1) {
        this.$alert('U kan niet meer dan 1 bestand uploaden.')
        return
      }
      const file = files[0]
      const fileSizeMb = Math.round((file.size / 1024 / 1024).toFixed(4) * 10) / 10
      if (fileSizeMb > 2) {
        const message = `Bestand mag niet groter zijn dan 2MB. Uw bestand is ${fileSizeMb} MB`
        this.$alert(message)
        e.currentTarget.value = ''
        return
      }
      this.file = file
    },
  },
}
</script>

<style scoped lang="stylus">
h3
  font-weight bold
  margin-bottom 3rem
  font-size 170%

.form-buttons
  margin-top 2rem

  button
    min-width 100px
</style>
